import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "m14.833 16-3.5-3.5A6.958 6.958 0 0 1 7 14c-3.854.02-7-3.125-7-7s3.146-7 7-7 7.02 3.146 7.02 7a7.047 7.047 0 0 1-1.5 4.333l3.48 3.5L14.833 16ZM7 1.667A5.344 5.344 0 0 0 1.667 7 5.344 5.344 0 0 0 7 12.333c2.938 0 5.354-2.375 5.354-5.333S9.958 1.667 7 1.667Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render() { return h(NuxtIcon, {icon: {render}}) } }